export default __webpack_public_path__ + "static/media/trash.1bad6c51.svg";